import { render, staticRenderFns } from "./type_3_Info.vue?vue&type=template&id=3836943f&scoped=true"
import script from "./type_3_Info.vue?vue&type=script&lang=js"
export * from "./type_3_Info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3836943f",
  null
  
)

export default component.exports